import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
// material
import { styled } from '@mui/material/styles';
import { Box, Toolbar, InputAdornment, Input } from '@mui/material';
import { useTranslation } from '../../common/LocalizationProvider';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 80,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 0, 0, 1)
}));

const SearchStyle = styled(Input)(({ theme }) => ({
  width: 200,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 240, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

PermissionSearch.propTypes = {
  searchName: PropTypes.string,
  onSearchName: PropTypes.func
};

export default function PermissionSearch({ searchName, onSearchName }) {
  const t = useTranslation();

  return (
    <RootStyle>
      <SearchStyle
        value={searchName}
        onChange={onSearchName}
        placeholder={t('tableSearch')}
        startAdornment={
          <InputAdornment position="start">
            <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
          </InputAdornment>
        }
      />
    </RootStyle>
  );
}
